import { render, staticRenderFns } from "./BankIndexView.vue?vue&type=template&id=707ecbae&scoped=true"
import script from "./BankIndexView.vue?vue&type=script&lang=js"
export * from "./BankIndexView.vue?vue&type=script&lang=js"
import style0 from "./BankIndexView.vue?vue&type=style&index=0&id=707ecbae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ecbae",
  null
  
)

export default component.exports